export default __webpack_public_path__ + "static/media/pin.912ac4f2.svg";